import AnimatedCounter from './AnimatedCounter';

/**
 * Individual Stat Card Component
 * @param {Object} stat - Stat data object containing title, value, icon, etc.
 */
const StatCard = ({ stat }) => {
  // Determine animation settings based on the value
  const getAnimationSettings = (value, category) => {
    let duration = 6000; // Increased base duration
    let easing = 'easeOut';
    let minDuration = 5000; // Minimum 2 seconds
    let maxDuration = 8000; // Maximum 6 seconds
    
    if (value < 100) {
      duration = 2500;
    } else if (value < 1000) {
      duration = 3500;
    } else {
      duration = 4500;
    }
    
    // Special cases for certain categories
    if (category === 'views') {
      easing = 'bounce';
    } else if (category === 'favorites') {
      easing = 'easeInOut';
      duration = 4000; // Even slower for favorites
    }
    
    return { duration, easing, minDuration, maxDuration };
  };

  const { duration, easing, minDuration, maxDuration } = getAnimationSettings(stat.value, stat.category);

  return (
    <div className={`hvnly-stat-card ${stat.category}`}>
      <div className="hvnly-stat-header">
        <div className="hvnly-stat-title">{stat.title}</div>
        <div className={`hvnly-stat-icon ${stat.category}`}>
          <i className={`fas fa-${stat.icon}`}></i>
        </div>
      </div>
      <AnimatedCounter 
        value={stat.value} 
        duration={duration}
        easing={easing}
        minDuration={minDuration}
        maxDuration={maxDuration}
        formatNumber={true}
      />
      <div className={`hvnly-stat-change ${stat.changeType}`}>
        <i className={`fas fa-${stat.changeType === 'positive' ? 'arrow-up' : 'arrow-down'}`}></i>
        {stat.change} from previous period
      </div>
    </div>
  );
};

export default StatCard;